import { render, staticRenderFns } from "./evaluationSection.vue?vue&type=template&id=9960accc&scoped=true"
import script from "./evaluationSection.vue?vue&type=script&lang=js"
export * from "./evaluationSection.vue?vue&type=script&lang=js"
import style0 from "./evaluationSection.vue?vue&type=style&index=0&id=9960accc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9960accc",
  null
  
)

export default component.exports